const snackbarIconVariantMap = {
    error: { iconName: 'Error', iconColor: 'danger' },
    info: { iconName: 'InfoOutline', iconColor: 'action' },
    success: { iconName: 'CheckCircleOutline', iconColor: 'success' },
    warning: { iconName: 'ErrorOutline', iconColor: 'warning' },
};
export const getSnackbarIconVariant = (variant) => snackbarIconVariantMap[variant];
